import * as BasketAction from './basket.action';
import * as fromBasket from './basket.select';
import * as MailAction from './mail/mail-basket.action';
import * as fromMail from './mail/mail-basket.select';
import * as VisioAction from './visio/visio-basket.action';
import * as fromVisio from './visio/visio-basket.select';

/**
 * MAIL
 */

const MailBasketAction = {
  ...MailAction,
  ...BasketAction,
};

const fromMailBasket = {
  ...fromMail,
  ...fromBasket,
};

/**
 * VISIO
 */

const VisioBasketAction = {
  ...VisioAction,
  ...BasketAction,
};

const fromVisioBasket = {
  ...fromVisio,
  ...fromBasket,
};

/**
 * EXPORT
 */

export { fromBasket, BasketAction, fromMailBasket, MailBasketAction, VisioBasketAction, fromVisioBasket };
